import type { DialoguePool } from '@/state/types';

export const L07_DIALOGUE: DialoguePool = {
  slowPlay: [
    'I\u2019ve seen more muscular tension in a bowl of custard.',
    'Push harder. With your fingers, I mean. The metaphor is beneath us.',
    'The rust is cosmetic. The weight is canonical. Both are disappointing you equally.',
  ],
  tokenLoss: [
    'Token retired due to trembling.',
    'One more rep! Put some soul into it, you sponge.',
    'Are we waiting for a spotter?',
  ],
  solution: [
    'The button is up. The bar for human achievement is down. Mind the trajectory.',
    'I\u2019d give you a medal, but it would only weigh you down.',
    'A minor feat of posture. Your evolution was clearly a side-project.',
  ],
  spite: [
    'Lighter, this time. Memory helps. Or rust weakened.',
  ],
};
